import { c as _c } from "react/compiler-runtime";
import { isAfter } from 'date-fns';
import { useContext } from 'react';
import { DashboardContext } from '../scenes/DashboardScene/DashboardContext';

/**
 * Determines if the current organization is actively in the quota enforcement period.
 *
 * When a free plan exceeds its quota (limit_exceeded_at is set), there is a grace period
 * (default 3 days) before events start being cancelled. This hook checks if the grace
 * period has ended and quota enforcement is now active.
 *
 * Timeline:
 * - Quota exceeded: limit_exceeded_at is set
 * - Grace period: Configurable days (default 3) where events continue to be delivered normally
 * - After grace period: New events are created with CANCELLED status and not delivered
 *
 * @returns {boolean} true if events are currently being cancelled, false if within grace period or no limit exceeded
 *
 * @see QuotaEnforcementBanner - Shows UI banner based on this state
 * @see server/services/Subscription.ts:isQuotaEnforcementActive - Server-side equivalent logic
 */
export function useIsQuotaEnforcementActive() {
  const $ = _c(2);
  const {
    subscription
  } = useContext(DashboardContext);
  if (!subscription?.quota_enforcement_at) {
    return false;
  }
  let t0;
  if ($[0] !== subscription.quota_enforcement_at) {
    t0 = isAfter(new Date(), new Date(subscription.quota_enforcement_at as string));
    $[0] = subscription.quota_enforcement_at;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}